import {BehaviorSubject, Observable} from 'rxjs';
import {Injectable} from "@angular/core";


const END_DATE = new Date("2023-11-28 12:00:00").getTime();

@Injectable()

export class CountdownService {

  private countdownSubject: BehaviorSubject<[string, string, string, string, string, string]> = new BehaviorSubject(['0', '0', '0', '0', '0', '0'] as [string, string, string, string, string, string]);
  countdown$: Observable<[string, string, string, string, string, string]> = this.countdownSubject.asObservable();

  constructor() {
    this.startCountdown();
  }

  public startCountdown() {
    const initialCountdown = this.calculateCountdown();
    this.countdownSubject.next(initialCountdown);

    setInterval(() => {
      const countdown = this.calculateCountdown();
      this.countdownSubject.next(countdown);
    }, 60000);
  }

  public calculateCountdown(): [string, string, string, string, string, string] {
    const nowDate = new Date().getTime();
    const date = Math.floor(nowDate / 60000) * 60000;
    const time =  END_DATE - date;
    const days = Math.floor(time / (60000 * 60 * 24));
    const hours = Math.floor((time - (60000 * 60 * 24 * days)) / (60000 * 60));
    const minutes = Math.floor((time - (60000 * 60 * 24 * days) - (60000 * 60 * hours)) / 60000);
    return [
      days.toString().toString().length === 1 ? '0' : days.toString()[0],
      days.toString().toString().length === 1 ? days.toString() : days.toString()[1],
      hours.toString().toString().length === 1 ? '0' : hours.toString()[0],
      hours.toString().toString().length === 1 ? hours.toString() : hours.toString()[1],
      minutes.toString().toString().length === 1 ? '0' : minutes.toString()[0],
      minutes.toString().toString().length === 1 ? minutes.toString() : minutes.toString()[1],
    ];
  }
}
